







































import { Vue, Component, Mixins } from 'vue-property-decorator';

import MyForm from '@/mixins/form';

@Component
export default class extends Mixins(MyForm) {
  params: any = {};

  handleSubmit() {
    this.form.validateFields(async (err: any, fieldValues: any) => {
      if (!err) {
        this.confirmLoading = true;
        // console.log(fieldValues);
        await this.saveOperationReason(fieldValues.ts_operation_reason);
        // console.log(this.$store.state.gOperationReason);
        if (this.params.onOk) {
          await this.params.onOk();
        }

        await this.handleCancel();
        this.confirmLoading = false;
      }
    });
  }

  handleCancel1() {
    if (this.params.onCancel) {
      this.params.onCancel();
    }

    this.handleCancel();
  }

  mounted() {
    // console.log(this.$store.state.gConfirmModalParams);
    this.params = this.$store.state.gConfirmModalParams;
  }
}
